import Vue from 'vue'
import Router from 'vue-router'

import Dashboard from '@/pages/Dashboard'

import Login from '@/components/Login/Login'
import LoginGoogle from '@/components/Login/LoginGoogle'
import Content from '@/components/Dashboard/Content'
import Usuarios from '@/components/Dashboard/Usuarios'
import Proyectos from '@/components/Dashboard/Proyectos'
import Informes from '@/components/Dashboard/Informes'
import MisInformes from '@/components/Dashboard/misinformes'

import FormUsusario from '@/components/Dashboard/forms/usuario'
import FormInforme from '@/components/Dashboard/forms/informe'
import iframeDashboard from '@/components/Dashboard/iframe'

Vue.use(Router)

export default new Router({
    mode: 'history',
    cors: true,
    routes: [{
            path: '/',
            name: 'Home',
            component: LoginGoogle,
        },
        {
            path: '/login',
            name: 'Login',
            component: LoginGoogle
        },
        {
            path: '/login2',
            name: 'Login2',
            component: Login
        },
        {
            path: '/dashboard',
            name: 'Dashboard',
            component: Dashboard,
            children: [{
                    path: 'usuarios',
                    name: 'Usuarios',
                    component: Usuarios,
                },
                {
                    path: 'proyectos',
                    name: 'proyectos',
                    component: Proyectos,
                    children: [{
                        path: ':proyecto/informes',
                        name: 'Proyectos informes',
                        component: Informes,
                    }]
                },
                {
                    path: 'form/informe',
                    name: 'Formulario nuevo informe',
                    component: FormInforme,
                },
                {
                    path: 'misinformes',
                    name: 'Mis informes disponibles',
                    component: MisInformes,
                },
                {
                    path: 'form/informe/:informe_id',
                    name: 'Formulario editar informe',
                    component: FormInforme,
                },
                {
                    path: 'form/usuario',
                    name: 'Formulario nuevo usuario',
                    component: FormUsusario,
                },
                {
                    path: 'form/usuario/:user_id',
                    name: 'Formulario editar usuario',
                    component: FormUsusario,
                },
                {
                    path: 'informe/:informe_id',
                    name: 'iframe',
                    component: iframeDashboard,
                },
            ],
            meta: { requiresAuth: true }
        }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js